import { useState } from "react";
import axios from "axios";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/operations`;

export default function GlobalSearch() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  const search = async (value) => {
    setQuery(value);
    if (value.trim().length < 2) return setResults([]);
    const response = await axios.get(`${API}/search`, { params: { q: value } });
    setResults(response.data.results);
  };

  const recordPath = (result) => result.type === "active job" ? `/active-jobs/${result.record_id}` : `/projects/${result.project_id}`;
  return <div className="global-search" data-testid="global-search"><Search size={16} /><input data-testid="global-search-input" onChange={(event) => search(event.target.value)} placeholder="Search projects, field assignments, locates, people, or follow-ups" value={query} />{results.length > 0 && <div className="search-results" data-testid="global-search-results">{results.map((result, index) => <Link data-testid={`search-result-${index}`} key={`${result.type}-${result.record_id}`} onClick={() => setResults([])} to={recordPath(result)}><span>{result.type === "active job" ? "field assignment" : result.type}</span><strong>{result.title}</strong><small>{result.subtitle}</small></Link>)}</div>}</div>;
}